// extracted by mini-css-extract-plugin
export var card = "style-module--card--0cd2b";
export var card_count = "style-module--card_count--40c29";
export var card_desc = "style-module--card_desc--6f5ba";
export var card_icon_wrap = "style-module--card_icon_wrap--47c61";
export var card_title = "style-module--card_title--75882";
export var card_title_wrap = "style-module--card_title_wrap--81b7a";
export var dev_process_content_wrap = "style-module--dev_process_content_wrap--285d5";
export var dev_process_title = "style-module--dev_process_title--04f92";
export var navigation_btn = "style-module--navigation_btn--f9ac2";
export var navigation_content = "style-module--navigation_content--d6aaf";
export var navigation_wrap = "style-module--navigation_wrap--02b24";
export var prev_btn = "style-module--prev_btn--ad7a2";